var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import axios from "./http.js";
import { _getLocale } from "../utils/locale";
const _NewsApi = class _NewsApi {
  // In-memory cache object
  static getNews() {
    const abortController = new AbortController();
    return {
      async call(params = {}) {
        const locale = _getLocale();
        const endpoint = `/v1/news`;
        const cacheKey = `${endpoint}?${new URLSearchParams(params).toString()}|locale=${locale}`;
        if (_NewsApi.cache.has(cacheKey)) {
          return Promise.resolve(_NewsApi.cache.get(cacheKey));
        }
        return axios.get(endpoint, {
          signal: abortController.signal,
          params
        }).then((response) => {
          _NewsApi.cache.set(cacheKey, response);
          return response;
        });
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
};
__publicField(_NewsApi, "cache", /* @__PURE__ */ new Map());
let NewsApi = _NewsApi;
var stdin_default = NewsApi;
export {
  stdin_default as default
};
